import Vue from 'vue'

export const uploadfiles = (data, headers, loading) => {
  let blob = new Blob([data], { type: 'application/octet-stream;charset=utf-8' })
  console.log(blob)
  let contentDisposition = headers['content-disposition']
  let patt = new RegExp("(?<=filename\\*=UTF-8'').*")
  let result = patt.exec(contentDisposition)
  let filename = result && result.length ? decodeURIComponent(result[0]) : '未命名'
  if (filename == '未命名') {
    loading.close()
    return
  }
  const href = URL.createObjectURL(blob)
  const el = Object.assign(document.createElement('a'), {
    href,
    style: { display: 'none' },
    download: filename,
  })
  document.body.appendChild(el)
  el.click()
  el.remove()
  URL.revokeObjectURL(href)
  loading.close()
}

// export default { uploadfiles }
